import { createUseStyles } from 'react-jss';
import { lighten } from '../../utils';
export default createUseStyles(function (theme) {
  return {
    button: {
      fontSize: 15,
      height: 48,
      outline: 'none',
      border: 'none',
      borderRadius: 5,
      cursor: 'pointer',
      backgroundColor: 'transparent',
      transition: '.1s',
      fontWeight: 500
    },
    'contained-primary': {
      backgroundColor: theme.palette.primary.regular,
      color: theme.palette.primary.text,
      '&:hover': {
        backgroundColor: theme.palette.hover.containedPrimary
      }
    },
    'outlined-primary': {
      border: "1px solid ".concat(theme.palette.primary.regular),
      color: theme.palette.primary.regular,
      '&:hover': {
        backgroundColor: theme.palette.primary.light
      }
    },
    'text-primary': {
      color: theme.palette.primary.regular,
      '&:hover': {
        color: theme.palette.hover.textPrimary
      }
    },
    'contained-secondary': {
      backgroundColor: theme.palette.secondary.regular,
      color: theme.palette.secondary.text,
      '&:hover': {
        backgroundColor: theme.palette.secondary.dark
      }
    },
    'outlined-secondary': {
      border: "1px solid ".concat(theme.palette.secondary.regular),
      color: theme.palette.secondary.regular,
      '&:hover': {
        backgroundColor: theme.palette.secondary.light
      }
    },
    'text-secondary': {
      color: theme.palette.secondary.regular,
      '&:hover': {
        color: theme.palette.secondary.dark
      }
    },
    'contained-success': {
      backgroundColor: theme.palette.success.regular,
      color: theme.palette.success.text,
      '&:hover': {
        backgroundColor: lighten(theme.palette.success.regular, -20)
      }
    },
    'outlined-success': {
      border: "1px solid ".concat(theme.palette.success.regular),
      color: theme.palette.success.regular,
      '&:hover': {
        backgroundColor: lighten(theme.palette.success.regular, 160)
      }
    },
    'text-success': {
      color: theme.palette.success.regular,
      '&:hover': {
        color: lighten(theme.palette.success.regular, -40)
      }
    },
    'contained-warning': {
      backgroundColor: theme.palette.warning.regular,
      color: theme.palette.warning.text,
      '&:hover': {
        backgroundColor: lighten(theme.palette.warning.regular, -10)
      }
    },
    'outlined-warning': {
      border: "1px solid ".concat(theme.palette.warning.regular),
      color: theme.palette.warning.regular,
      '&:hover': {
        backgroundColor: lighten(theme.palette.warning.regular, 160)
      }
    },
    'text-warning': {
      color: theme.palette.warning.regular,
      '&:hover': {
        color: lighten(theme.palette.warning.regular, -40)
      }
    },
    'contained-danger': {
      backgroundColor: theme.palette.danger.regular,
      color: theme.palette.danger.text,
      '&:hover': {
        backgroundColor: lighten(theme.palette.danger.regular, -10)
      }
    },
    'outlined-danger': {
      border: "1px solid ".concat(theme.palette.danger.regular),
      color: theme.palette.danger.regular,
      '&:hover': {
        backgroundColor: lighten(theme.palette.danger.regular, 160)
      }
    },
    'text-danger': {
      color: theme.palette.danger.regular,
      '&:hover': {
        color: lighten(theme.palette.danger.regular, -40)
      }
    },
    uppercase: {
      textTransform: 'uppercase'
    },
    'contained-disabled': {
      pointerEvents: 'none',
      backgroundColor: theme.palette.grey[2],
      color: theme.palette.grey[8]
    },
    'outlined-disabled': {
      pointerEvents: 'none',
      borderColor: theme.palette.grey[2],
      color: theme.palette.grey[8],
      backgroundColor: 'transparent'
    },
    'text-disabled': {
      pointerEvents: 'none',
      color: theme.palette.grey[8],
      backgroundColor: 'transparent'
    }
  };
});